export const getAdminPasswordErrorCode = (password) => {
  const value = String(password || '');

  if (value !== value.trim()) return 'spaces';
  if (value.length < 6) return 'length';
  return '';
};
